export default __webpack_public_path__ + "img/InterDisplay-ThinItalic_2c7e437.woff2";